<template>
  <!-- eslint-disable -->
  <div class='temp-controls'>
    <div class='mini-controls'>
      {{clientName}}
      <button @click='showFullControls = !showFullControls'>Toggle full controls</button>
      <button @click="hasSceneAnimations = !hasSceneAnimations">
        Animations -
        <span v-if='hasSceneAnimations === true'>ON</span>
        <span v-if='hasSceneAnimations === false'>OFF</span>
      </button>
      <button @click='goToResults'>Go to results</button>
      <button @click='applyChangesToScene'>Apply</button>
      <slot name='mini' />
    </div>

    <div
      class='full-controls'
      v-show='showFullControls'
    >
      <slot />
      <table border='0'>
        <slot name='table'></slot>
        <tr>
          <th><a
              href='#'
              @click.prevent="moveToItem('house')"
            >house</a></th>
          <td>{{ house }}</td>
          <td>
            <button @click="selectHouseStatus(0)">0</button>
            <button @click="selectHouseStatus(1)">1</button>
            <button @click="selectHouseStatus(2)">2</button>
            <button @click="selectHouseStatus(3)">3</button>
          </td>
        </tr>
        <tr>
          <th><a
              href='#'
              @click.prevent="moveToItem('transport')"
            >transport</a></th>
          <td>{{ transport }}</td>
          <td>
            <button @click="selectTransportStatus(0)">0</button>
            <button @click="selectTransportStatus(1)">1</button>
            <button @click="selectTransportStatus(2)">2</button>
            <button @click="selectTransportStatus(3)">3</button>
          </td>
        </tr>
        <tr>
          <th><a
              href='#'
              @click.prevent="moveToItem('personal')"
            >personal</a></th>
          <td>{{ personal }}</td>
          <td>
            <button @click="selectPersonalStatus(0)">0</button>
            <button @click="selectPersonalStatus(1)">1</button>
            <button @click="selectPersonalStatus(2)">2</button>
            <button @click="selectPersonalStatus(3)">3</button>
          </td>
        </tr>
        <tr>
          <th><a
              href='#'
              @click.prevent="moveToItem('eatout')"
            >eatout</a></th>
          <td>{{ eatout }}</td>
          <td>
            <button @click="selectEatoutStatus(0)">0</button>
            <button @click="selectEatoutStatus(1)">1</button>
            <button @click="selectEatoutStatus(2)">2</button>
            <button @click="selectEatoutStatus(3)">3</button>
          </td>
        </tr>
        <tr>
          <th><a
              href='#'
              @click.prevent="moveToItem('holiday')"
            >holiday</a></th>
          <td>{{ holiday }}</td>
          <td>
            <button @click="selectHolidayStatus(0)">0</button>
            <button @click="selectHolidayStatus(1)">1</button>
            <button @click="selectHolidayStatus(2)">2</button>
            <button @click="selectHolidayStatus(3)">3</button>
          </td>
        </tr>
        <tr>
          <th><a
              href='#'
              @click.prevent="moveToItem('food')"
            >food</a></th>
          <td>{{ food }}</td>
          <td>
            <button @click="selectFoodStatus(0)">0</button>
            <button @click="selectFoodStatus(1)">1</button>
            <button @click="selectFoodStatus(2)">2</button>
            <button @click="selectFoodStatus(3)">3</button>
          </td>
        </tr>
        <tr>
          <th><a
              href='#'
              @click.prevent="moveToItem('treat')"
            >treat</a></th>
          <td>{{ treat }}</td>
          <td>
            <button @click="selectTreatStatus(0)">0</button>
            <button @click="selectTreatStatus(1)">1</button>
            <button @click="selectTreatStatus(2)">2</button>
            <button @click="selectTreatStatus(3)">3</button>
          </td>
        </tr>
      </table>
      <p>
        <strong>Active: </strong>{{ activeItem }}<br />
        <strong>showForeground: </strong>{{ showForeground }}
      </p>
      <p>
        <strong>Queue: </strong>
        {{ changesToBeMade }}
      </p>
      <slot name='footer'></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data () {
    return {
      showFullControls: false,
      clientName: process.env.VUE_APP_CLIENT,
    }
  },
  computed: {
    ...mapFields([
      'scene.status.house',
      'scene.status.transport',
      'scene.status.personal',
      'scene.status.eatout',
      'scene.status.holiday',
      'scene.status.food',
      'scene.status.treat',
      'scene.changesToBeMade',
      'ui.hasSceneAnimations',
      'ui.showForeground',
    ]),
    ...mapGetters([
      'activeItem',
    ]),
  },
  methods: {
    ...mapMutations([
      'selectIsCohabiting',
      'selectIsInLondon',
      'selectHouseStatus',
      'selectTransportStatus',
      'selectPersonalStatus',
      'selectEatoutStatus',
      'selectHolidayStatus',
      'selectFoodStatus',
      'selectTreatStatus',
      'goToPage',
      'moveToItem',
      'applyChangesToScene',
    ]),
    goToResults () {
      this.hasSceneAnimations = false;
      this.selectIsCohabiting(false);
      this.selectIsInLondon(false);
      this.selectHouseStatus(1);
      this.selectTransportStatus(2);
      this.selectPersonalStatus(3);
      this.selectEatoutStatus(3);
      this.selectHolidayStatus(2);
      this.selectFoodStatus(1);
      this.selectTreatStatus(2);
      this.goToPage('results');
      this.hasSceneAnimations = true;
    },
  },
};
</script>

<style lang='scss'>

.temp-controls {
  font-family: sans-serif;
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background: rgba(255,255,255,0.5);
  padding: 0.375rem;
  border-radius: 4px;
  font-size: 0.75rem;
}

</style>
